export default "__VITE_ASSET__D154jHBH__"